import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InputText } from "primereact/inputtext";
import { json } from "stream/consumers";
import { JVDropdown } from "../../../shared/JVDropdown";
import { IUsersDropdown } from "../../../models/IDropdown";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    tableData: [],
    open: boolean,
    hideDialoge: () => void,
    toast: any
}

interface formSchema {
    total_Recived_Amount: number,
    paymentStatus: string,
    payment_Mode: string,
    transaction_ID: string,
}

const schema = yup.object({

});

export const AssignedSalesForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [salesManager, setSalesManager] = useState<Array<IUsersDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<formSchema>({
        resolver: yupResolver(schema),
        //defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onHide = () => {
        props.hideDialoge();
    }

      const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
            let queryParameter = null;
            if (branch != 0 && branch != null) {
                queryParameter = `branch_ID=${branch}`;
            } else if (company != 0 && company != null) {
                queryParameter = `company_ID=${company}`;
            } else if (team != 0 && team != null) {
                queryParameter = `team_ID=${team}`;
            }
    
            const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
            if (response) {
                const data: Array<IUsersDropdown> = await response.json();
                const emptyData = {
                    login_ID: 0,
                    user_Name: "-- SELECT --"
                };
                data.unshift(emptyData);
                setSalesManager(data);
            }
        }


    const onSubmitBulk = (data:any) => {
        console.log(data)
    }


    useEffect(() => {
        if (props.open) {
            loadSales(0,0,0)
        };
    }, [props.open]);

    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.open} onHide={() => onHide()} header="Assigned To Sales Manager" >
                <form onSubmit={handleSubmit(onSubmitBulk)} className="p-fluid formgrid grid" >
                   
                    <JVDropdown column={1} label="Sales Manager" control={control} name="salesManager_ID" options={salesManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" />
                    <Button label="Assign" type="submit" loading={loading} />
                </form>
            </Dialog>
        </>
    );
}